// pictures
import p1 from './photogallery/Romir-shred-part-3.webp';
import p2 from './photogallery/AIden-smile.png';
import p3 from './photogallery/TheGroove.png';
import p4 from './photogallery/Understanding.png';
import p5 from './photogallery/IMG_4920.jpeg';
import p6 from './photogallery/No we arnt doing Ed Sheeren .webp'
import p7 from './photogallery/Spencer-shredding-_1_.webp';


export const pictures = [
    {
        id: 0,
        thumbnail: p1,
        title: 'Romir'
    },
    {
        id: 1,
        thumbnail: p2,
        title: 'Aiden'
    },
    {
        id: 2,
        thumbnail: p3,
        title: 'Matt'
    },
    {
        id: 3,
        thumbnail: p4,
        title: 'Spencer'
    },
    {
        id: 4,
        thumbnail: p5,
        title: '"Static Disturbance"'
    },
    {
        id: 5,
        thumbnail: p6,
        title: '"No we ain\'t doing Ed Sheeran"'
    },
    {
        id: 6,
        thumbnail: p7,
        title: '"Power Stance"'
    }
];